import { Component, Input } from "@angular/core";
import { Observable, of } from "rxjs";

@Component({
  selector: "app-inside-survey-validate-remarks",
  templateUrl: "./inside-survey-validate-remarks.component.html",
  styleUrls: ["./inside-survey-validate-remarks.component.scss"],
})
export class InsideSurveyValidateRemarksComponent {
  @Input() remarks: string;

  constructor() {}

  save(checkValidity?: boolean): Observable<any> {
    return of(true);
  }
}
